import styled, {css} from 'styled-components';

import {mixins} from '../styles';

interface TColorProps {
  color: string;
  isFull?: boolean;
}

export const ColorPalette = styled.div`
  margin: 0 ${({theme}) => theme.spacing.s5};
`;

export const ColorsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: ${({theme}) => theme.spacing.s1};
`;

export const PaletteColumn = styled.div`
  ${mixins.column};
`;

export const Header = styled.h2`
  ${mixins.f8}
`;

export const Color = styled.div<TColorProps>`
  ${mixins.flexAlign('space-between', 'center')}
  ${({theme, color, isFull}) => css`
    ${mixins.wh(isFull ? '100%' : '20%', '70px')}
    background-color: ${color};
    padding: ${theme.spacing.s2};
  `};
`;

export const ColorName = styled.div`
  ${({theme}) => css`
    background-color: ${theme.palette.white};
    padding: ${theme.spacing.s1};
    border-radius: 16px;
  `};
`;

export const ColorCode = styled(ColorName)`
  margin-left: 20px;
`;

export const SmallTitle = styled.h3`
  ${mixins.f3}
  text-transform: capitalize;
`;
